<template>
    <div id="listing-preferences">
        <status-message></status-message>
        <div class="lists-header td-flex">
            <h1 class="td-h2">Listing Preferences</h1>
        </div>
        <div class="tabs-bar td-card border mt-1">
            <div class="td-tabs secondary">
                <span :class="[preferencesQuery.type == PreferenceType.Preferred ? 'active' : '', 'td-tab']" @click.prevent="updateTab(PreferenceType.Preferred)">Favorites</span>
                <span :class="[preferencesQuery.type == PreferenceType.Avoid ? 'active' : '', 'td-tab']" @click.prevent="updateTab(PreferenceType.Avoid)">Avoided</span>
            </div>
        </div>
        <generic-pager :currentCount="listingPreferences.length" :count="preferncesCount" :pageCount="pageCount" :lastObject="lastPagerObject" @update-list="updateList" :reset="resetList" :loading="isLoading">
            <div class="listing-preferences td-table-container mt-0" v-if="listingPreferences && listingPreferences.length > 0">
                <table cellspacing="0" cellpadding="0" class="td-table">
                    <thead>
                        <tr class="table-header">
                            <th>Account</th>
                            <th>User </th>
                            <th class="number">Priority </th>
                            <th class="number">Radius </th>
                            <th class="services">Services </th>
                            <th class="td-text-right"></th>
                        </tr>
                    </thead>
                    <tbody v-if="!isLoading && listingPreferences.length > 0" class="rows-container">
                        <tr class="table-row main-row" v-for="(item, index) in listingPreferences" :key="item.id">
                            <td class="name">
                                <strong class="show-mobile">Account: </strong>  <h2 class="td-h5 mt-0">
                                    <a class="td-link no-underline" title="View Account" :href="item.accountUrl"> {{item.accountName }}</a>
                                </h2>
                            </td>
                            <td>
                                <strong class="show-mobile">User: </strong><a class="td-link no-underline" title="View User" :href="item.userUrl">  {{ item.userName }}</a>
                            </td>
                            <td class="number">
                                <strong v-if="item.priority" class="show-mobile">Priority: </strong>
                                <span v-if="item.priority">{{ item.priority }}</span>
                            </td>
                            <td class="number">
                                <strong class="show-mobile">Radius: </strong>
                                <span>{{ item.radius || "Default" }}</span>
                            </td>
                            <td class="services">
                                <strong class="show-mobile" v-if="item.services.length > 0">Services: </strong>
                                <span>{{ item.services.join(', ')}}</span>
                            </td>

                            <td class="table-actions">
                                <div class="td-flex">
                                    <a class="td-btn secondary-outlined slim icon-left" title="View User" :href="item.userUrl">
                                        <icon type="solid" name="faEye" aria-hidden="true"></icon> View User
                                    </a>
                                    <a class="td-btn secondary-outlined slim icon-left" title="View Account" :href="item.accountUrl">
                                        <icon type="solid" name="faEye" aria-hidden="true"></icon> View Account
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-if="isLoading">
                        <tr><th colspan="5"><div class="loading"><icon name="faSpinner" type="solid" spin></icon></div></th></tr>
                    </tbody>
                </table>
            </div>
        </generic-pager>
    </div>
    <div v-if="listingPreferences && listingPreferences.length < 1 && !isLoading" class="td-banner warning no-icon mt-2">
        <p v-if="preferencesQuery.type == PreferenceType.Preferred">This listing has not been added to preffered yet.</p>
        <p v-if="preferencesQuery.type == PreferenceType.Avoid">This listing has not been added to avoided.</p>
    </div>
   
</template>

<script>
    import script from './ListingPreferences';
    export default script;</script>

<style lang="less">
    @import "./ListingPreferences.less";
</style>